import styled from "@emotion/styled";
import { NEGATIVE_FEEDBACK_COMMENTS, POSITIVE_FEEDBACK_COMMENTS } from "../../../constants/feedback-comments";
import { colors, radius, spacing } from "../../design-tokens";
import { ActionButton } from "../../primitives/action-button";

const CommentContainer = styled.div`
  border: 1px solid ${colors.border};
  border-radius: ${radius.md}px;
  padding: ${spacing.lg}px;
  box-sizing: border-box;
`;

const CommentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing.md}px;
  box-sizing: border-box;
`;

const CommentActionButton = styled(ActionButton)`
  width: 100%;
  text-align: center;
  white-space: normal;
  height: auto;
  min-height: 44px;
  padding: ${spacing.md}px ${spacing.lg}px;
  font-size: 14px;
  font-weight: 400;
`;

type CommentOptionsProps = {
  readonly selectedComment: string | null;
  readonly isSubmitting: boolean;
  readonly isPositive: boolean;
  readonly onCommentSelect: (comment: string) => void;
};

export function CommentOptions({ selectedComment, isSubmitting, isPositive, onCommentSelect }: CommentOptionsProps) {
  const comments = isPositive ? POSITIVE_FEEDBACK_COMMENTS : NEGATIVE_FEEDBACK_COMMENTS;

  return (
    <CommentContainer>
      <CommentGrid>
        {comments.map(comment => (
          <CommentActionButton
            key={comment}
            variant="secondary"
            isActive={selectedComment === comment}
            onClick={() => onCommentSelect(comment)}
            disabled={isSubmitting}
            aria-label={`Select feedback reason: ${comment}`}
          >
            {comment}
          </CommentActionButton>
        ))}
      </CommentGrid>
    </CommentContainer>
  );
}
